import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    activateConfirm: String,
    deactivateConfirm: String,
  };

  submit(event) {
    const checkbox = event.target;
    const message = checkbox.checked
      ? this.activateConfirmValue
      : this.deactivateConfirmValue;

    if (!window.confirm(message)) {
      checkbox.checked = !checkbox.checked;
      return;
    }

    this.element.requestSubmit();
  }
}
